import Vue from "vue";
import axios from "axios"; // eslint-disable-line
import { PROYECT } from "@/constant";

// Full config:  https://github.com/axios/axios#request-config
axios.defaults.baseURL = PROYECT.API_URL || "";
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.post.Accept = "application/json";
axios.defaults.timeout = 10000;

const _axios = axios.create(); // eslint-disable-line

_axios.interceptors.request.use(config => config, error => Promise.reject(error));

// Add a response interceptor
_axios.interceptors.response.use(response => response, error => Promise.reject(error));

// eslint-disable-next-line
Plugin.install = (Vue, options) => {
  Vue.axios = _axios; // eslint-disable-line
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    }
  });
};

Vue.use(Plugin);

export default Plugin;
